import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "../../CommonElements";
import PageContainer from "../../Layout/Containers/PageContainer";
import AbsenContain from "../../Component/Absen/containers/AbsenContain";

const AbsenPage = () => {
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const type = parameters.get("type");
  return (
    <PageContainer breadcrumbs={<Breadcrumbs parent="Sipeg" title={type === "tahunan" ? "Rekap Absen Bulanan" : type === "bulanan" ? "Rekap Absen Bulanan" : "List Absen"} />}>
      <AbsenContain />
    </PageContainer>
  );
};

export default AbsenPage;
